module.exports = __webpack_public_path__ + "static/img/abH2.37a8e5b3.png";